export default "__VITE_ASSET__CiUT6Gfz__";